import { Tooltip } from "antd";
import React from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { toolTipDescriptions } from "../helpers";

const InputField = ({
  label,
  id,
  name,
  type = "text",
  value,
  onChange,
  placeholder,
  toolTip = false, // Showing description of the field via tooltip
  required = false,
  disabled = false,
  inputRef, // Add this prop
  onKeyDown, // Add onKeyDown prop
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex  items-center">
        <label htmlFor={id} className="">
          {label}
        </label>
        <span className="text-red-500 pl-1">{required && ` *`}</span>
        {toolTip && (
          <Tooltip title={toolTipDescriptions?.[toolTip] || "No description"}>
            <span className="text-lg text-blue-500 px-1 cursor-pointer">
              <IoMdInformationCircleOutline />
            </span>
          </Tooltip>
        )}
      </div>

      {/* Input */}
      <input
        type={type}
        id={id}
        disabled={disabled}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown} // Add onKeyDown handler
        ref={inputRef} // Apply the ref here
        className={`w-full text-black border  border-gray-300 ${
          disabled ? "bg-gray-200" : "bg-white"
        } flex justify-between items-center p-2 rounded-md outline-none focus:ring-1 focus:ring-blue-600 focus:border-blue-600 duration-500`}
      />
    </div>
  );
};

export default InputField;
